module.exports = __webpack_public_path__ + "img/blue.44b23762.png";